module.exports = __webpack_public_path__ + "static/media/snowremoval.2178b4c1.png";